import * as React from 'react';
import { AutoCompleteItem } from './internal/AutoCompleteItem.js';
export var SuggestionList = function (_a) {
    var onSelect = _a.onSelect, suggestions = _a.suggestions, loading = _a.loading, visible = _a.visible, cursor = _a.cursor;
    var ref = React.useRef(undefined);
    React.useEffect(function () {
        var container = ref.current;
        if (container && cursor >= 0 && cursor < suggestions.length) {
            var item = container.children.item(cursor);
            if (item) {
                var area = item.parentElement.parentElement;
                var top_1 = item.offsetTop - area.scrollTop;
                var bottom = top_1 + item.clientHeight;
                if (top_1 < 0) {
                    item.scrollIntoView(true);
                }
                else if (bottom > area.offsetHeight) {
                    item.scrollIntoView(false);
                }
            }
        }
    }, [cursor, suggestions]);
    if (loading) {
        return (React.createElement("div", { className: "tag-search-result is-loading" },
            React.createElement("div", { className: "spinner circles" })));
    }
    else if (visible && suggestions.length > 0) {
        return (React.createElement("div", { className: "tag-search-result" },
            React.createElement("ul", { className: "list-group", ref: ref }, suggestions.map(function (suggestion, idx) { return (React.createElement(AutoCompleteItem, { onSelect: onSelect, key: idx, isHighlighted: cursor === idx, name: typeof suggestion === 'string' ? suggestion : suggestion.display, value: typeof suggestion === 'string' ? suggestion : suggestion.value })); }))));
    }
    // tslint:disable-next-line:no-null-keyword
    return null;
};
//# sourceMappingURL=index.js.map